export const ACTION_SET = '@SET';
export const ACTION_INC = '@INC';
export const ACTION_DEL = '@DEL';
export const ACTION_PUSH = '@PUSH';
export const ACTION_PULL = '@PULL';
export const ACTION_PULL_WHERE = '@PULL_WHERE';
